import React from 'react'
import { useStyles } from './styles'
import { useSelector } from 'react-redux'
import { Box, Link } from '@material-ui/core'

export const SettingsSectionGroupItem = ({
    name,
    icon,
    IconComponent,
    onClick,
    url
}) => {
    const { theme } = useSelector(state => state.main)
    const classes = useStyles(theme)

    return (
        <Box onClick={onClick} className={classes.groupItemWrapper}>
            {IconComponent ? <IconComponent /> : <img src={icon} alt="icon" />}

            <Link className={classes.text} href={url} target="_blank">
                {name}
            </Link>
        </Box>
    )
}
